import './App.css';
import Ipod from './components/Ipod'

function App() {
  return (
    <div className="App">
      <Ipod />
    </div>
  );
}

export default App;
